import { isBrowserExtensionError } from './stackTrace';
import { ErrorOrigin } from './types';

export const getErrorOrigin = (stackTrace: string | undefined): ErrorOrigin => {
  if (!stackTrace) {
    return ErrorOrigin.UNKNOWN;
  }

  if (isBrowserExtensionError(stackTrace)) {
    return ErrorOrigin.BROWSER_EXTENSION;
  }

  return ErrorOrigin.MICRO_FRONTEND;
};
